<script lang="ts">
  import { userbaseStore } from "../../stores/stores";
  import { createEventDispatcher, onMount } from "svelte";
  import Button from "../../shared/Button.svelte";
  import Input from "../../shared/Input.svelte";
  import type { Entry } from "../../stores/types";
  import moment from "moment";

  export let inventoryItem: Entry, itemId: string;
  let dispatch = createEventDispatcher();
  let fieldAmount = 0;
  let fieldDate = moment().format("yyyy-MM-DD");
  let updatePromise = null;
  let databaseName = "inventory";

  const submitHandler = () => {
    inventoryItem.amount = inventoryItem.amount - fieldAmount;
    inventoryItem.lastUsed = new Date(fieldDate);
    updatePromise = $userbaseStore.updateItem({
      databaseName,
      itemId,
      item: inventoryItem,
    });
    var logItem = {
      action: "update-use",
      changedItem: inventoryItem,
    };
    updatePromise = $userbaseStore.insertItem({
      databaseName: "logs",
      item: logItem,
    });

    dispatch("updateItem");
  };
</script>

<form class="form" on:submit|preventDefault={submitHandler}>
  <h2>Etwas gebacken?</h2>
  <Input
    label="Name"
    value={inventoryItem.article.item.name}
    type="text"
    disabled
  />
  <Input label="Menge" bind:value={fieldAmount} type="number" required />
  <Input label="verwendet am" bind:value={fieldDate} type="date" />
  <Button type="primary" flat={true}>Verbrauch eintragen</Button>
</form>
